import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import LazyImage from './LazyImage';

function Gallery({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const handleItemClick = (path) => {
        navigate(`/${slug}/${path}`);
    };

    const cols = info.extra?.elementsInARow || 3;
    const content = info.extra?.content || '';

    return (
        <div className="justify" style={{ width: '100%' }}>
            {info.title && <h1>{info.title}</h1>}
            <div className="justify">
                {typeof content === "string" && content ? parse(content) : null}
            </div>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${cols}, 1fr)`,
                    gap: "12px",
                    width: "100%"
                }}
            >
                {(info.children || []).map((page, idx) => (
                    <div key={idx} className="category-block" onClick={() => handleItemClick(page.slug)} style={{ cursor: "pointer" }}>
                        <div style={{ overflow: "hidden" }}>
                            {page.preview ? (
                                <LazyImage
                                    src={page.preview}
                                    alt={page.title}
                                    className="catalog-image"
                                    style={{ aspectRatio: "16 / 9", width: "100%" }}
                                    imgStyle={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
                                />
                            ) : (
                                <div className="catalog-image" style={{ backgroundColor: "#f0ebe0", aspectRatio: "16 / 9", width: "100%" }} />
                            )}
                        </div>
                        <div style={{ padding: "8px 4px 0" }}>
                            <span className="imageTitle">{page.title}</span>
                        </div>
                    </div>
                ))}
            </div>
            {slug.split('/').length > 1 &&
                <button
                    className="btn-back"
                    onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
                >
                    Go Back
                </button>
            }
        </div>
    );
}

export default Gallery;
